"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  Complimentary: 'complimentary',
  Check: 'check',
  Cash: 'cash',
  'Credit Card': 'creditCard',
  Wire: 'wire',
  Other: 'other'
};
exports.default = _default;